import ScrollableContainer from "../../Componant/BonusUI/Scrollable";

const Scrollable = () => {
  return (
    <div className="page-body">
      <ScrollableContainer />
    </div>
  );
};

export default Scrollable;
